import { render } from "./LedgerTableOld.vue?vue&type=template&id=6d37266f&scoped=true"
import script from "./LedgerTableOld.vue?vue&type=script&lang=js"
export * from "./LedgerTableOld.vue?vue&type=script&lang=js"

import "./LedgerTableOld.vue?vue&type=style&index=0&id=6d37266f&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d37266f"]])

export default __exports__